import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FacilitatorNavbar from '../components/FacilitatorNavbar';
import AdminNavbar from '../components/AdminNavbar';
import QANavbar from '../components/QANavbar';
import CustomEmailComposer from '../components/CustomEmailComposer';
import { useAuth } from '../auth/AuthContext';
import ExternalNavbar from '../components/ExternalNavbar';
import '../styles/brand.css';

const EmailComposer = () => {
  const { userProfile } = useAuth();

  // Render appropriate navbar based on role
  const renderNavbar = () => {
    switch (userProfile?.role) {
      case 'admin':
        return <AdminNavbar currentPage="email-composer" />;
      case 'qa':
        return <QANavbar />;
      case 'external_facilitator_limited':
        return <ExternalNavbar />;
      default:
        return <FacilitatorNavbar currentPage="email-composer" />;
    }
  };

  return (
    <div>
      {renderNavbar()}

      {/* Hero Section */}
      <section className="hero-section">
        <Container>
          <Row>
            <Col lg={8}>
              <h1 className="mb-3">Email Composer</h1>
              <p className="mission-text mb-4">
                Communicate effectively with learners and schedule important messages
              </p>
              <p className="mb-0">
                Send custom emails to learners, schedule holiday greetings, set up recurring communications, and manage email campaigns for your programs.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <main style={{ paddingTop: '20px' }}>
        <CustomEmailComposer />
      </main>
    </div>
  );
};

export default EmailComposer;
